import { tenantRouterModel } from 'APP/model/model';
import { IGetDiscoverDestinationsRequestParams } from 'APP/model/tenantRouter/tenantRouterModel.types';
import Entities from 'STORE';

export async function getDiscoverDestinations(
  params: IGetDiscoverDestinationsRequestParams
): Promise<boolean> {
  try {
    const result = await tenantRouterModel.getDiscoverDestinations(params);
    Entities.authStore.addDiscoverDestinations(result);
    return true;
  } catch {
    return false;
  }
}
